/**
 * Main application entry point.
 */

'use strict';

var app = require('mag-app');


app.once('load', function () {
    require('spa-gettext').load({name: core.environment.language}, function () {
        app.karaokeBackend = core.plugins.karaokeBackend;

        require('./modules/saver').init(true, false);

        app.pages = {
            main: require('./pages/main')
        };

        app.karaokeBackend.getTracks(app.state.SEARCH ? {search: app.state.SEARCH} : {favorite: app.state.DISPLAY_FAV}, function ( error, data ) {
            if ( !error ) {
                app.route(app.pages.main, data);
                app.ready();
            }
        });
    });
});
